import { Surface } from '../../../../specification/Surface';
import { CaseSpecification } from '../../../../specification/cases/CaseSpecification';

// Return forced rbs value or default rbs value (= min rbs)
export const getCaseProjectedRbsFromSpecifications = (
  caseSpecification: CaseSpecification,
  minRbs: Surface
): Surface => caseSpecification.surfaces.realBuiltSurface || minRbs;
